import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  streetAddress: "",
  selectedProvince: null,
  selectedCity: null,
  selectedPostCode: null,
  complete: false,
};

const direccionPersonaSlice = createSlice({
  name: "direccionPersona",
  initialState,
  reducers: {
    direccionPersonaSelectProvincia: (state, action) => {
      state.selectedProvince = action.payload.provinciaSelected;
      state.selectedCity = null;
      state.selectedPostCode = null;
      state.streetAddress = "";
      state.complete = false;
    },
    direccionPersonaSelectLocalidad: (state, action) => {
      state.selectedCity = action.payload.localidadSelected;
      state.selectedPostCode = null;
      state.streetAddress = "";
      state.complete = false;
    },
    direccionPersonaSelectCodigoPostal: (state, action) => {
      state.selectedPostCode = action.payload.codigoPostalSelected;
      state.streetAddress = "";
      state.complete = false;
    },
    direccionPersonaSelectStreet: (state, action) => {
      state.streetAddress = action.payload.streetSelected;
      state.complete = false;
    },
    direccionPersonaComplete: (state, action) => {
      state.complete = action.payload.complete;
    },
    direccionPersonaClear: (state) => {
      state.streetAddress = "";
      state.selectedProvince = null;
      state.selectedCity = null;
      state.selectedPostCode = null;
      state.complete = false;
    },
  },
});

export const {
  direccionPersonaSelectProvincia,
  direccionPersonaSelectLocalidad,
  direccionPersonaSelectCodigoPostal,
  direccionPersonaSelectStreet,
  direccionPersonaComplete,
  direccionPersonaClear,
} = direccionPersonaSlice.actions;

export default direccionPersonaSlice.reducer;
